export default "__VITE_ASSET__CjitU8$3__"